import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "getInitials",
})
export class GetInitialsPipe implements PipeTransform {
  transform(name: string,letters:number = 2): string {
    if (!name) return "";

    // Remove commas and special chars
    const cleanName = name.replace(/,/g, "");

    // Split into words
    const words = cleanName.trim().split(/\s+/);

    // Take first two initials
    const initials = words
      .slice(0, letters)
      .map((w) => w.charAt(0).toUpperCase())
      .join("");

    return initials;
  }
}
